import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect, Suspense, lazy } from 'react';
import { getAnalytics, logEvent } from 'firebase/analytics';
// Lazy load pages for better performance
const HomePage = lazy(() => import('../pages/Home/HomePage'));
const FacilitiesPage = lazy(() => import('../pages/Facilities/FacilitiesPage'));
const PromoPage = lazy(() => import('../pages/Promo/PromoPage'));
const AboutUsPage = lazy(() => import('../pages/AboutUs/AboutUsPage'));
const PineGardenPage = lazy(() => import('../pages/Project/Residence/PineGardenPage'));
const VirginiaPinePage = lazy(() => import('../pages/Project/Residence/VirginiaPinePage'));
const NorthernPinePage = lazy(() => import('../pages/Project/Residence/NorthernPinePage'));
const MorizoraPage = lazy(() => import('../pages/Project/Residence/MorizoraPage'));
const CommercialPage = lazy(() => import('../pages/Project/Commercial/CommercialPage'));
const BusinessDistrictPage = lazy(() => import('../pages/Project/BusinessDistrict/BusinessDistrictPage'));
const NewsPage = lazy(() => import('../pages/News/NewsPage'));
const NewsPageDetail = lazy(() => import('../pages/News/Detail/NewsDetailPage'));
import WhatsAppFloatingButton from '../components/common/WhatsAppFloatingButton';

import ScrollToTop from '../components/common/ScrollToTop';
import DocumentTitle from '../components/common/DocumentTitle';

const AppRouterContent = () => {
  const location = useLocation();

  useEffect(() => {
    try {
      const analytics = getAnalytics();
      logEvent(analytics, 'page_view', {
        page_path: location.pathname,
        page_title: document.title,
      });
    } catch (error) {
      // Track analytics failure as error event
      try {
        const analytics = getAnalytics();
        logEvent(analytics, 'analytics_error', {
          error_type: 'page_view_tracking_failed',
          page_path: location.pathname,
        });
      } catch (trackingError) {
        // Final silent fallback - cannot track if error tracking fails
        // Could implement: localStorage error queue, console.error in dev, or external error reporting
      }
    }
  }, [location]);

  return (
    <>
      <DocumentTitle />
      <ScrollToTop />
      <Suspense
        fallback={
          <div className="min-h-screen flex items-center justify-center">
            <div className="text-center">
              <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto"></div>
              <p className="mt-4 text-lg text-gray-600">Loading...</p>
            </div>
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<Navigate to="/home" replace />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/facilities" element={<FacilitiesPage />} />
          <Route path="/promo" element={<PromoPage />} />
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/projects/residence/pine-garden" element={<PineGardenPage />} />
          <Route path="/projects/residence/virginia-pine" element={<VirginiaPinePage />} />
          <Route path="/projects/residence/northern-pine" element={<NorthernPinePage />} />
          <Route path="/projects/residence/morizora" element={<MorizoraPage />} />
          <Route path="/projects/commercial" element={<CommercialPage />} />
          <Route path="/projects/business-district" element={<BusinessDistrictPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/news/detail/:id" element={<NewsPageDetail />} />
        </Routes>
      </Suspense>

      <WhatsAppFloatingButton />
    </>
  );
};

const AppRouter = () => {
  return (
    <BrowserRouter>
      <AppRouterContent />
    </BrowserRouter>
  );
};

export default AppRouter;
